import {
  mdiAccountCircle,
  mdiLogout,
  mdiInformationOutline,
  mdiFileDownloadOutline,
  mdiPageFirst,
  mdiPageLast,
  mdiChevronLeft,
  mdiChevronRight,
  mdiAlertCircleOutline,
} from '@mdi/js';

export const IconMap: Record<string, string> = {
  account: mdiAccountCircle,
  logout: mdiLogout,
  information: mdiInformationOutline,
  filedownload: mdiFileDownloadOutline,
  pageFirst: mdiPageFirst,
  pageLast: mdiPageLast,
  chevronLeft: mdiChevronLeft,
  chevronRight: mdiChevronRight,
  alert: mdiAlertCircleOutline,
};
